import { GettingStartedStep, gettingStartedStepEnum } from "@gap/backend/app-services/user/models/UserEntityDtoSchema"

export const getVisibleGettingStartedSteps = (params: { hasMyOrganisationPermission: boolean, hasCalendarToggle: boolean }): GettingStartedStep[] => {
   return gettingStartedStepEnum.filter(step => {
      if (step === 'inviteTeamMember') return params.hasMyOrganisationPermission
      if (step === 'connectCalendar') return params.hasCalendarToggle
      return true
   })
}

/** How many of the advisor's completed steps are steps they can still see. */
export const completedVisibleStepCount = (params: { completedSteps: GettingStartedStep[], visibleSteps: GettingStartedStep[] }): number => {
   const completedSteps = new Set(params.completedSteps)
   return params.visibleSteps.filter(step => completedSteps.has(step)).length
}
